import React, { useState } from "react";
import InvoiceDataGrid from "../invoiceList/InvoiceDataGrid";
import InvoiceActivityLogs from "../invoiceList/InvoiceActivityLogs";
import DocumentHeader from "../invoiceList/DocumentHeader";
import useDocumentList from "../../hooks/useDocumentList";
import Modal from "../common/CommonModal";
// import BarcodePrintingModal from "./BarcodePrintingModal";
import canUserSeeThis from "../common/CheckCanUserSeeThis";

const PurchaseEnquiryList = () => {
  const [p1Value, setP1Value] = useState("FULL");
  const [modalType, setModalType] = useState(null);
  const [barcodeModalOpen, setBarcodeModalOpen] = useState(false);
  const [newArrivalModalOpen, setNewArrivalModalOpen] = useState(false);

  const {
    config,
    searchTerm,
    setSearchTerm,
    searchType,
    setSearchType,
    showSidebar,
    setShowSidebar,
    columnVisibilityModel,
    setColumnVisibilityModel,
    documentData,
    columns,
    rows,
    selectionModel,
    setSelectionModel,
    selectedRowData,
    setSelectedRowData,
    loading,
    handleEdit,
    exportDocumentList,
    handleView,
    pageNumber,
    setPageNumber,
    currentEnd,
    currentStart,
    totalCount,
    refreshDocumentList,
  } = useDocumentList({
    docType: "PENQ",
    p1Value,
    p2Value: "-",
    docNoField: "PO NO",
    editRoute: "/purchase_enquiry",
    screenCode: "PENQCOUNT",
    initialSearchType: "-",
  });
  const handleExport = () => {
    exportDocumentList();
  };
  const handleBarcodeClick = () => {
    setBarcodeModalOpen(true);
  };

  const handleNewArrivalClick = () => {
    setNewArrivalModalOpen(true);
  };

  return (
    <div className="flex flex-col h-screen bg-gray-50 overflow-hidden">
      <div className="flex-shrink-0">
        <DocumentHeader
          showSidebar={showSidebar}
          setShowSidebar={setShowSidebar}
          BASE_URL={config.BASE_URL}
          COMPANY_CODE={config.COMPANY_CODE}
          DEPARTMENT={config.DEPARTMENT_NO}
          title={"Purchase Enquiry List"}
          searchTerm={searchTerm}
          searchType={searchType}
          setSearchTerm={setSearchTerm}
          setSearchType={setSearchType}
          filteredDocs={documentData}
          showType={p1Value}
          setShowType={setP1Value}
          total={totalCount}
          onExport={handleExport}
          documentType={"PURCHASE_ENQUIRY"}
          config={config}
          selectedRowData={selectedRowData}
          doctype="PENQ"
          showFilter={false}
          onBarcodeClick={handleBarcodeClick}
          onNewArrivalClick={handleNewArrivalClick}
        />
      </div>

      <div className="flex-1 min-h-0 px-2 py-2">
        <div className="h-full grid grid-cols-12 gap-4">
          {showSidebar && (
            <div className="col-span-12 lg:col-span-3 h-full overflow-auto">
              <InvoiceActivityLogs
                invoiceId={selectedRowData["SRVNO"]}
                COMPANY_CODE={config.COMPANY_CODE}
                BASE_URL={config.BASE_URL}
                modificationType={"PINVTIMELINE"}
                printType={"PINVPRINTTIMELINE"}
                DEPARTMENT={config.DEPARTMENT_NO}
              />
            </div>
          )}
          <div
            className={`col-span-12 ${showSidebar ? "lg:col-span-9" : "lg:col-span-12"
              } h-full transition-all duration-300`}
          >
            <InvoiceDataGrid
              rows={rows}
              columns={columns}
              loading={loading}
              selectionModel={selectionModel}
              setSelectionModel={setSelectionModel}
              setSelectedRowData={setSelectedRowData}
              selectedRowData={selectedRowData}
              onEdit={handleEdit}
              onView={handleView}
              columnVisibilityModel={columnVisibilityModel}
              setColumnVisibilityModel={setColumnVisibilityModel}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              currentStart={currentStart}
              currentEnd={currentEnd}
              totalCount={totalCount}
              showSidebar={showSidebar}
              docLabel={"SRV"}
              enableF5Action={true}
              config={config}
              refreshDocumentList={refreshDocumentList}
              modalType={"manager"}
              setModalType={setModalType}
              showEdit={config.CURRENT_USER_ROLE?.toUpperCase() === "ADMIN" ||
                canUserSeeThis("NY")} />
          </div>
        </div>
      </div>
      {/* <Modal
        isOpen={barcodeModalOpen}
        onClose={() => setBarcodeModalOpen(false)}
        title={`Barcode Printing - ${selectedRowData?.SRVNO}`}
        size="xxl"
      >
        <BarcodePrintingModal
          config={config}
          invNo={
            selectedRowData?.SRVNO ||
            selectedRowData?.INVNO ||
            selectedRowData?.["DO NO"] ||
            ""
          }
          onClose={() => setBarcodeModalOpen(false)}
          onPrinted={() => {
            setBarcodeModalOpen(false);
            refreshDocumentList();
          }}
        />{" "}
      </Modal> */}

      <Modal
        isOpen={newArrivalModalOpen}
        onClose={() => setNewArrivalModalOpen(false)}
        title="Register New Arrival"
        size="xl"
      >
        {/* <NewArrivalModal
          config={config}
          onClose={() => setNewArrivalModalOpen(false)}
          onSuccess={() => {
            setNewArrivalModalOpen(false);
            refreshDocumentList();
          }}
        /> */}
        New arrival Listing Modal
      </Modal>
    </div>
  );
};

export default PurchaseEnquiryList;
